export default class UserStat
{
    constructor() {
      this.job_total = 0
      this.completed_jobs = 0
      this.inspections = 0
      this.failed_inspections = 0
      this.passed_inspections = 0
      this.latest_inspection = ''
    }
}